// Cognitive/Psychosocial Development subsection form field enum
export enum CognitivePsychosocialFormField {
  COGNITIVE_PSYCHOSOCIAL_COMMUNICATION_ASSESSMENT = 'medical-background/cognitive-psychosocial-dev/communication-assessment',
  COGNITIVE_PSYCHOSOCIAL_COGNITIVE_ASSESSMENT = 'medical-background/cognitive-psychosocial-dev/cognitive-assessment',
  COGNITIVE_PSYCHOSOCIAL_HISTORY_SUBSTANCE_ABUSE = 'medical-background/cognitive-psychosocial-dev/history-substance-abuse',
  COGNITIVE_PSYCHOSOCIAL_SUBSTANCE_ABUSE_NOTES = 'medical-background/cognitive-psychosocial-dev/substance-abuse-notes',
  COGNITIVE_PSYCHOSOCIAL_SYSTEM_SUMMARY = 'medical-background/cognitive-psychosocial-dev/system-summary'
}
